const ATTRIBUTION_KEY = 'adwary_acquisition_attribution';

export const UTM_LIMITS = {
  utm_source: 100,
  utm_medium: 100,
  utm_campaign: 150,
};

function sanitize(value, maxLength) {
  return String(value || '')
    .replace(/[\u0000-\u001F\u007F]/g, '')
    .trim()
    .slice(0, maxLength);
}

export function getAttribution() {
  try {
    const stored = JSON.parse(sessionStorage.getItem(ATTRIBUTION_KEY) || '{}');
    return Object.keys(UTM_LIMITS).reduce((result, key) => {
      const value = sanitize(stored[key], UTM_LIMITS[key]);
      if (value) result[key] = value;
      return result;
    }, {});
  } catch {
    return {};
  }
}

export function captureAttribution(search = window.location.search) {
  const params = search instanceof URLSearchParams
    ? search
    : new URLSearchParams(search || '');
  const captured = { ...getAttribution() };

  Object.entries(UTM_LIMITS).forEach(([key, limit]) => {
    const value = sanitize(params.get(key), limit);
    if (value) captured[key] = value;
  });

  try {
    sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(captured));
  } catch {
    // Storage may be unavailable; returning the captured values still works.
  }
  return captured;
}

export function appendAttribution(path, attribution = getAttribution()) {
  const url = new URL(path, window.location.origin);
  Object.keys(UTM_LIMITS).forEach((key) => {
    const value = sanitize(attribution[key], UTM_LIMITS[key]);
    if (value) url.searchParams.set(key, value);
  });
  return `${url.pathname}${url.search}${url.hash}`;
}
